
import { Directive, HostListener, ElementRef, Output, EventEmitter } from "@angular/core";

@Directive({
    selector: '[dollar]'
})

export class DollarDirective {

    @Output() valueChange = new EventEmitter();
    @Output() validate = new EventEmitter();

    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft', 'Left', 'Right', 'Decimal'];

    constructor(private el: ElementRef) {
    }

    @HostListener('keyup', ['$event']) keyup(event: KeyboardEvent) {
        var reg1 = /^[<|>|=](\s+)?[0-9,]+(\.[0-9]*){0,1}$/;
        var reg2 = /^[0-9,]+(\.[0-9]*){0,1}$/;
        let current: string = this.el.nativeElement.value;
        if (current.toLowerCase()) {
            if (!reg1.test(current.toLowerCase()) && !reg2.test(current.toLowerCase()))
                this.validate.emit(true);
            else
                this.validate.emit(false);
        }
        else {
            this.validate.emit(false);
        }
    }

    @HostListener('input') onInput() {
        this.valueChange.emit(this.dollarModel);
    }

    get dollarModel(): any {

        var _elmValue = this.el.nativeElement.value;
        var _operator = _elmValue.charAt(0);
        switch (_operator) {
            case "<":
            case ">":
            case "=": 
            {
                var _value = _elmValue.substr(1, _elmValue.length).replace(/\,/g, '');
                break;
            }
            default: {
                var _value = _elmValue.replace(/\,/g, '');
                _operator = "=";
                break;
            }
        }

        return { value: _value.trim(), sign: _operator }
    }



}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/dollar-validate-directive.ts